<form [formGroup]="form">
  <div class="grid">
    @for (item of fields; track $index) {
      @if (!editable) {
        @if (item.visible == undefined || item.visible == "view") {
          <div
            [class]="
              type == 'horizontal'
                ? 'col-5 overflow-hidden'
                : 'lg:col-4 md:col-4 sm:col-6 overflow-hidden'
            "
          >
            @if (translation) {
              <span class="label-text">{{ item.label | translate }}</span>
            } @else {
              <span class="label-text">{{ item.label }}</span>
            }
          </div>
          <div
            [class]="
              type == 'horizontal'
                ? 'col-7 overflow-hidden'
                : 'lg:col-4 md:col-4 sm:col-6 overflow-hidden'
            "
          >
            @if (item.customStyle) {
              <div style="display: inline-flex">
                <p-tag
                  class="api-tag"
                  [value]="item.value | translate"
                  [severity]="
                    item.status === KeyStatusNonActivated
                      ? tagType.secondary
                      : item.status === keyStatusActivated
                        ? tagType.success
                        : tagType.danger
                  "
                ></p-tag>
                @if (item.actionButton.isDisplayed) {
                  @if (item.actionButton.type === actionApiKeyActivate) {
                    <p-button [link]="true" (click)="openActivateApiKeyModal()">
                      <i class="pi pi-plus-circle"></i
                      ><span class="button-label ml-2">{{
                        "modalApiKey.activateKeyApi.title" | translate
                      }}</span>
                    </p-button>
                    @if (isKeyActivated) {
                      <app-api-key-modal
                        [config]="activatedKeyApiModalConfig"
                        (closeDialog)="closeActivateApiKeyModal()"
                      ></app-api-key-modal>
                    } @else {
                      <app-api-key-modal
                        [config]="activateKeyApiModalConfig"
                        (closeDialog)="closeActivateApiKeyModal()"
                      ></app-api-key-modal>
                    }
                  } @else {
                    <p-button
                      [link]="true"
                      (click)="openRegenerateApiKeyModal()"
                    >
                      <i class="pi pi-undo"></i
                      ><span class="button-label ml-2">{{
                        "modalApiKey.generateKeyApi.title" | translate
                      }}</span>
                    </p-button>
                    @if (isKeyRegenerated) {
                      <app-api-key-modal
                        [config]="regeneratedKeyApiModalConfig"
                        (closeDialog)="closeRegenerateApiKeyModal()"
                      ></app-api-key-modal>
                    } @else {
                      <app-api-key-modal
                        [config]="regenerateKeyApiModalConfig"
                        (closeDialog)="closeRegenerateApiKeyModal()"
                      ></app-api-key-modal>
                    }
                  }
                }
              </div>
            } @else {
              <span class="value-text" [pTooltip]="item.tooltip"
                >{{ item.value }}
                @if (item.iconClass) {
                  <i [class]="item.iconClass"></i>
                }
              </span>
            }
          </div>
        }
      } @else {
        @if (item.visible == undefined || item.visible == "edit") {
          @if (item.visibleLabel) {
            <div
              [class]="
                type == 'horizontal' ? 'col-5' : 'lg:col-4 md:col-4 sm:col-6'
              "
            >
              @if (translation) {
                <span class="label-text">{{ item.label | translate }}</span>
              } @else {
                <span class="label-text">{{ item.label }}</span>
              }
            </div>
          }
          <div
            [class]="
              type == 'horizontal' ? 'col-7' : 'lg:col-4 md:col-4 sm:col-6'
            "
          >
            @if (item.customStyle) {
              <div style="display: inline-flex">
                <p-tag
                  class="api-tag"
                  [value]="item.value | translate"
                  [severity]="
                    item.status === KeyStatusNonActivated
                      ? tagType.secondary
                      : item.status === keyStatusActivated
                        ? tagType.success
                        : tagType.danger
                  "
                ></p-tag>
              </div>
            } @else {
              @switch (item.type) {
                @case (types.input) {
                  @if (item.iconPrefix) {
                    <p-iconField iconPosition="left" class="w-full">
                      <p-inputIcon [styleClass]="item.iconPrefix" />
                      <input
                        type="text"
                        pInputText
                        [formControlName]="item.name"
                        placeholder="{{ item.placeholder | translate }}"
                        class="w-full"
                      />
                    </p-iconField>
                  } @else if (item.numericOnly) {
                    <app-phone-input [formControlName]="item.name"></app-phone-input>
                    <!-- <input
                    type="text"
                    pInputText
                    [formControlName]="item.name"
                    placeholder="{{ item.placeholder | translate}}"
                    (keypress)="
                      allowOnlyNumbers($event, item.numericOnly)
                    "
                    class="w-full "
                  /> -->

                  } @else{
                    <input
                      type="text"
                      pInputText
                      [formControlName]="item.name"
                      placeholder="{{ item.placeholder | translate }}"
                      (keypress)="
                        allowOnlyAlphabets($event, item.alphabeticOnly)
                      "
                      class="w-full "
                    />
                  }
                }
                @case (types.multiselect) {
                  <p-multiSelect
                    [options]="item.options"
                    [formControlName]="item.name"
                    [filter]="true"
                    class="w-full "
                    optionLabel="name"
                    placeholder="{{ item.placeholder | translate }}"
                  ></p-multiSelect>
                }
                @case (types.select) {
                  <p-select
                    [formControlName]="item.name"
                    [options]="item.options"
                    [optionLabel]="item.optionLabel"
                    placeholder="{{ item.placeholder | translate }}"
                    class="w-full "
                  >
                    @if (item.composite) {
                      <ng-template let-selectedItem pTemplate="selectedItem">
                        <span class="inline font-bold line-height-1">
                          {{ selectedItem["shopName"] + " - " }}
                        </span>
                        <span class="inline line-height-1">
                          {{ selectedItem["shopChannel"]["channelName"] }}
                        </span>
                      </ng-template>
                      <ng-template let-viewItem pTemplate="item">
                        <span class="inline font-bold line-height-1 ">
                          {{ viewItem["shopName"] + " - " }}
                        </span>
                        <span class="inline line-height-1 pl-1">
                          {{ viewItem["shopChannel"]["channelName"] }}
                        </span>
                      </ng-template>
                    }
                  </p-select>
                }
                @case (types.spacer) {
                  <p></p>
                }
                @case (types.button) {
                  @if (item.subType == "outlined") {
                    <p-button
                      label="Primary"
                      [icon]="item.iconPrefix"
                      [style]="{ width: item.width ? item.width : '100%' }"
                      [outlined]="true"
                      (click)="openDialog()"
                    ></p-button>
                  } @else if (item.subType == "text") {
                    <p-button
                      [icon]="item.iconPrefix"
                      label="{{ item.value | translate }}"
                      [text]="true"
                      (click)="emitAction(item)"
                    ></p-button>
                  }
                }
              }
            }
          </div>
        }
      }
    }
  </div>
  @if(error) {
    <p-message [severity]="error.severity" [text]="error.text"  />
  }

</form>
